var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6997 10.9H3.69971M16.6997 2.90002V6.90002M8.69971 2.90002V6.90002M8.49971 22.9H16.8997C18.5799 22.9 19.4199 22.9 20.0617 22.573C20.6262 22.2854 21.0851 21.8265 21.3727 21.262C21.6997 20.6203 21.6997 19.7802 21.6997 18.1V9.70002C21.6997 8.01987 21.6997 7.17979 21.3727 6.53805C21.0851 5.97357 20.6262 5.51462 20.0617 5.227C19.4199 4.90002 18.5799 4.90002 16.8997 4.90002H8.49971C6.81955 4.90002 5.97947 4.90002 5.33774 5.227C4.77325 5.51462 4.31431 5.97357 4.02669 6.53805C3.69971 7.17979 3.69971 8.01987 3.69971 9.70002V18.1C3.69971 19.7802 3.69971 20.6203 4.02669 21.262C4.31431 21.8265 4.77325 22.2854 5.33774 22.573C5.97947 22.9 6.81955 22.9 8.49971 22.9Z",
    stroke: "#44739E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.4b88c8cd.svg";
export { ForwardRef as ReactComponent };